<template>
  <div class="profile-page__content">
    <v-notification>
    </v-notification>
    <Modal
        v-if="isMounted"
        :style="showModal ? 'display: block' : 'display: none'"
        :show="showModal"
        modal-class="profile-modal"
        @close="toggleShowModal"
    >
      <template #body>
        <div class="modal-content">
          <div class="profile-modal__title">{{ getLocalization(modalData.title) }}</div>
          <div class="auth__form">
            <div class="auth-form-element">
              <div class="auth-form-element__head">
                <div class="auth-form-element__label">{{getLocalization(modalData.old[0])}}*</div>
              </div>
              <label v-if="modalData.apiMethod" class="auth-form-element__input input-password">
                <input
                    v-model="userData[modalData.userDataOld]"
                    type="text" disabled autocomplete="off"
                    :placeholder="getLocalization(modalData.old[1])"
                />
              </label>
              <label v-else class="auth-form-element__input input-password">
                <input
                    v-model="userData[modalData.userDataOld]"
                    :type="modalData.userData === 'contact' ? 'text' : 'password'"
                    :disabled="!!modalData.old[2]"
                    autocomplete="off"
                    :placeholder="getLocalization(modalData.old[1])"
                />
                <div v-show="modalData.userData !== 'contact'" class="--button">
                  <img src="/img/svg/common/glass-off.svg" alt=""/>
                </div>
              </label>
              <div class="auth-form-element__help"></div>
            </div>
            <div class="auth-form-element">
              <div class="auth-form-element__head">
                <div class="auth-form-element__label">{{getLocalization(modalData.new[0])}}*</div>
              </div>
              <label class="auth-form-element__input input-password">
                <input
                    v-model="userData[modalData.userData]"
                    :type="modalData.userData === 'contact' ? 'text' : 'password'"
                    autocomplete="off"
                    :placeholder="getLocalization(modalData.new[1])"
                />
                <div v-show="modalData.userData !== 'contact'" class="--button">
                  <img src="/img/svg/common/glass-off.svg"/>
                </div>
              </label>
              <div class="auth-form-element__help"></div>
            </div>
            <div v-if="modalData.repeatNew" class="auth-form-element">
              <div class="auth-form-element__head">
                <div class="auth-form-element__label">{{getLocalization(modalData.repeatNew[0])}}*</div>
              </div>
              <label class="auth-form-element__input input-password">
                <input
                    v-model="userData[modalData.userDataRepeat]"
                    type="password"
                    autocomplete="off"
                    :placeholder="getLocalization(modalData.repeatNew[1])"
                />
              </label>
              <div class="auth-form-element__help"></div>
            </div>
          </div>
          <div class="auth__button">
            <button class="button orange" @click="changeUserData(!!modalData.apiMethod)">
              <img src="/img/svg/common/shield.svg" alt=""/>
              {{getLocalization(modalData.btn)}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
        v-if="isMounted"
        :style="this.showSuccessModal ? 'display: block' : 'display: none'"
        :show="this.showSuccessModal"
        modal-class="profile-modal custom-modal-notification"
        @close="this.showSuccessModal = false"
    >
      <template #body>
        <div class="modal-content custom-modal-notification">
          <img src="/img/png/notification/change-api-key.png" class="custom-modal-notification__image"/>
          <div class="custom-modal-notification__message">{{getLocalization(successData.title)}}</div>
          <div class="profile-modal__view-info">
            <div class="--label">{{ successData.msg }}</div>
            <div class="--value">
              {{ successData.result }}
            </div>
          </div>
          <div class="custom-modal-notification__button">
            <button
                class="button orange"
                type="button"
                data-bs-toggle="modal"
                @click="showSuccessModal = false"
                data-bs-target="#modal-change-api-key-success"
            >
              {{getLocalization('Okay')}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
        :style="this.showModalApi ? 'display: block' : 'display: none'"
        :show="this.showModalApi"
        modal-class="profile-modal custom-modal-notification"
        @close="closeShowApi"
    >
      <template #body>
        <div class="modal-content">
          <div class="profile-modal__title">{{ getLocalization('Show') }} API key</div>
          <div class="auth__form">
            <div class="auth-form-element">
              <div class="auth-form-element__head">
                <div class="auth-form-element__label">{{getLocalization('Enter your password to view your API key')}}*</div>
              </div>
              <label class="auth-form-element__input input-password">
                <input
                    v-model="userData.showTokenPassword"
                    type="password"
                    autocomplete="off"
                    :placeholder="getLocalization('Your password')"
                />
                <div class="--button">
                  <img src="/img/svg/common/glass-off.svg"/>
                </div>
              </label>
              <div class="auth-form-element__help"></div>
            </div>
          </div>
          <div class="auth__button">
            <button class="button orange" @click="showToken()">
              <img src="/img/svg/common/shield.svg" alt=""/>
              {{getLocalization('Show')}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
        :style="this.showUserNotifyModal ? 'display: block' : 'display: none'"
        :show="this.showUserNotifyModal"
        :scrollable="true"
        modal-class="profile-modal custom-modal-notification"
        @close="closeShowApi"
    >
      <template #body>
        <div class="modal-content custom-modal-notification">
          <img src="/img/png/notification/change-api-key.png" class="custom-modal-notification__image"/>
          <div class="custom-modal-notification__message">{{getLocalization('Info')}}</div>
          <div class="profile-modal__view-info">
            <div class="--label">{{getLocalization('To add notifications, please contact support')}}</div>
          </div>
          <div class="custom-modal-notification__button">
            <button
                class="button orange"
                type="button"
                data-bs-toggle="modal"
                @click="showUserNotifyModal = false"
            >
              {{getLocalization('Okay')}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <div class="profile-page__elements">
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">ID</div>
        </div>
        <div class="profile-form-item__body">
          <span>{{this.user['id']}}</span>
          <button class="button primary" disabled>
            {{ getLocalization('Not available to change')}}
          </button>
        </div>
      </div>
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">{{getLocalization('Login/Email')}}</div>
        </div>
        <div class="profile-form-item__body">
          <span>{{this.user['name']}}</span>
          <button class="button primary" disabled>
            {{ getLocalization('Not available to change')}}
          </button>
        </div>
      </div>
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">Email</div>
        </div>
        <div class="profile-form-item__body">
          <span>{{this.user['email']}}</span>
          <button class="button primary" disabled>
            {{getLocalization('Not available to change')}}
          </button>
        </div>
      </div>
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">{{getLocalization('My contact')}}</div>
        </div>
        <div class="profile-form-item__body">
          <span>{{this.user['contact']}}</span>
          <button class="button primary" data-bs-target="#profilePassword" @click="changeModalData(contactModalData)">{{ getLocalization('Change')}}</button>
        </div>
      </div>
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">{{getLocalization('Password')}}</div>
        </div>
        <div class="profile-form-item__body">
          <span>************</span>
          <button class="button primary" data-bs-target="#profilePassword" @click="changeModalData(passwordModalData)">{{getLocalization('Change')}}</button>
        </div>
      </div>
      <div class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">{{getLocalization('API-key')}}</div>
        </div>
        <div class="profile-form-item__body">
          <span>{{this.userData.api_token}}</span>
          <button class="button primary btn-show-api"
                  @click="showModalApi = true"
                  data-bs-target="#modal-show-api-key">
            {{getLocalization('Show')}}</button>
          <button class="button primary"
                  @click="changeModalData(apiModalData)"
                  data-bs-target="#modal-change-api-key">
            {{getLocalization('Change')}}</button>
        </div>
      </div>
      <div v-if="!isPartner" class="auth-form-element profile-form-item">
        <div class="auth-form-element__head">
          <div class="auth-form-element__label">{{getLocalization('Balance bot')}}</div>
        </div>
        <div class="bot-wrapper">
          <div>
            <span class="bot-span">{{getLocalization('Minimum balance for alert')}}</span>
            <div class="d-flex gap-1">
              <input @keyup.enter="updateUser" placeholder="5000" v-model="userData.min_balance" type="text" class="bot-input">
              <span class="bot-span-info">{{getLocalization('rub')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="profile-page__divider"></div>-->
<!--    <div class="profile-page__tariff">-->
<!--      <div class="&#45;&#45;title">{{getLocalization('Your plan')}}</div>-->
<!--      <div class="&#45;&#45;message">-->
<!--        {{getLocalization('Your rate as a buyer depends on the volume and regularity of purchases')}}-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import BaseAdminMixin from "../../admin/components/mixins/BaseAdminMixin";
import Multiselect from "vue-multiselect";
import Modal from "../../components/table/modalNew.vue";

export default {
  name: "phoneHistory",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    Multiselect,
    Modal
  },
  props: [
    'user',
    'userRate',
    'isPartner'
  ],
  data() {
    return {
      PARTNER: 1,
      CLIENT: 3,
      WHOLESALE: 4,
      userData: {
        name: this.user.name,
        contact: this.user.contact,
        api_token: this.user.api_token,
        password: null,
        oldPassword: null,
        repeatPassword: null,
        showTokenPassword: null,
        min_balance: null,
      },
      rate: null,
      email: this.user.email,
      userModel: {},
      oldUserModel: {},
      showModal: false,
      showSuccessModal: false,
      passwordModalData: {
        title: 'Change a password',
        old: ['Old password', 'Your old password'],
        new: ['New password', 'Your new password'],
        repeatNew: ['Confirm your new password', 'Confirm your new password'],
        btn: 'Change password',
        successImg: '/img/png/notification/change-password.png',
        userDataOld: 'oldPassword',
        userDataRepeat: 'repeatPassword',
        userData: 'password'
      },
      apiModalData: {
        title: 'Change your API-key',
        old: ['Current API-key', 'Your current API-key', true],
        new: ['Change your API-key', 'Your password'],
        btn: 'Change API-key',
        successImg: '/img/png/notification/change-api-key.png',
        userDataOld: 'api_token',
        userData: 'showTokenPassword',
        apiMethod: true
      },
      contactModalData: {
        title: 'change your contact',
        old: ['Current contact', 'Your current contact', true],
        new: ['New contact', 'Your new contact'],
        btn: 'Change a contact',
        successImg: '/img/png/notification/change-password.png',
        userData: 'contact',
        userDataOld: 'contact'
      },
      modalData: {},
      isMounted: false,
      showModalApi: false,
      successData: {
        title: '',
        msg: '',
        result: ''
      },
      userTelegramChatId: null,
      isNeedUserSettingsModal: false,
      showUserNotifyModal: false
    }
  },
  mounted() {
    this.userModel = this.user;
    this.oldUserModel = Object.assign({}, this.userModel);
    this.rate = this.userRate;
    this.modalData = this.passwordModalData;
    this.isMounted = true;
    this.userData.min_balance = this.user?.user_setting?.min_balance;
    this.userTelegramChatId = this.user?.user_setting?.chat_id;

  },
  methods: {
    updateUser: async function () {
      let data = [];
      if (this.userData.password !== null) {
        // if (this.userData.password !== this.userData.repeatPassword) {
        //   await this.alertMessage(this.getLocalization('Password don`t match'), 'error');
        //   return;
        // }
        if (this.userData.oldPassword == null) {
          await this.alertMessage(this.getLocalization('Type your old password'), 'error')
        } else {
          data.push({
            id: this.userModel.id,
            password: this.userData.password,
            oldPassword: this.userData.oldPassword,
            password_confirmation: this.userData.repeatPassword
          })
        }
      }
      for (let userInfo in this.userModel) {
        if (this.oldUserModel[userInfo] != this.userData[userInfo] && this.userData[userInfo]) {
          data.push({
            id: this.userModel.id,
            [userInfo]: this.userData[userInfo]
          })
        }
        if (userInfo === 'user_setting') {
          if (this.oldUserModel[userInfo]?.['min_balance'] !== this.userData.min_balance) {
            this.isNeedUserSettingsModal = true;
            data.push({
              id: this.userModel.id,
              min_balance: this.userData.min_balance
            });
          }
        }
      }
      data = Object.assign({}, ...data);
      if (Object.keys(data).length > 0) {
        let response = await this.sendRequest('/cabinet/profile/update', 'post', data);
        if (response['status'] == 'ok') {
          await this.alertMessage(this.getLocalization('Data successfully updated'));
          this.needUserModalNotify();
          if (data.password !== null) {
            if (data.oldPassword !== null) {
              setTimeout(function() {
                location.reload();
              }, 2500);
            }
          } else {
            for (let userInfo in this.userData) {
              this.userData[userInfo] = this.userModel[userInfo];
            }
          }
        }
      }
    },
    async showToken() {
      let password = this.userData.showTokenPassword;
      if (password) {
        let response = await this.sendRequest('/cabinet/profile/getUserToken', 'post', {
          password: password
        });
        if (response['status'] == 'ok') {
          this.successData = Object.assign({}, {title: 'Ваш API-КЛЮЧ', msg: 'Ваш API-КЛЮЧ', result: response['api_token']})
          this.showModalApi = false;
          this.showSuccessModal = true;
        }
      } else {
        await this.alertMessage(this.getLocalization('Type your password'), 'error');
      }
    },
    async updateUserToken() {
      let password = this.userData.showTokenPassword;
      if (password) {
        let response = await this.sendRequest('/cabinet/profile/getUserToken', 'post', {
          password: password
        });
        if (response['status'] == 'ok') {
          let data = {
            id: this.userModel.id,
            updateToken: true,
          }
          let response = await this.sendRequest('/cabinet/profile/update', 'post', data);
          if (response['status'] == 'ok') {
            let response = await this.sendRequest('/cabinet/profile/getUserToken', 'post', {
              password: password
            });
            this.userData.api_token = response['api_token'];
            this.successData = Object.assign({}, {title: 'Ваш API-КЛЮЧ успешно ИЗМЕНЁН!', msg: 'Новый API-ключ'})
            await this.alertMessage(this.getLocalization('Api token updated successfully'));
            setTimeout(function() {
              location.reload();
            }, 2500);
          }
        }
        this.userData.showTokenPassword = null
      } else {
        await this.alertMessage(this.getLocalization('Type your password'), 'error');
      }
    },
    changeUserData(api = false) {
      if (api) {
        return this.updateUserToken();
      }
      return this.updateUser();
    },
    toggleShowModal() {
      this.showModal = !this.showModal;
    },
    closeShowApi() {
      this.showModalApi = false;
      this.showUserNotifyModal = false;
    },
    changeModalData(data) {
      this.modalData = data;
      this.toggleShowModal();
    },
    needUserModalNotify() {
      if (!this.userTelegramChatId && this.isNeedUserSettingsModal) {
        this.showUserNotifyModal = true;
        this.isNeedUserSettingsModal = false;
      }
    }
  }
}
</script>
